// export default function userPopupOpen() {
//   const userLink = document.querySelector(".user-icon");
//   const userPopup = document.querySelector(".user-popup");
//   const closePopup = document.querySelector(".user-close");

//   userLink.addEventListener("click", (e) => {
//     e.preventDefault();

//     if (userPopup.classList.contains("opened")) {
//       userPopup.classList.remove("opened");
//     } else {
//       userPopup.classList.add("opened");
//     }
//   });

//   closePopup.addEventListener("click", () => {
//     if (userPopup.classList.contains("opened")) {
//       userPopup.classList.remove("opened");
//     }
//   });
// }

import { Modal } from "bootstrap";

const userPopupOpen = () => {
  if (document.querySelector(".js-user-modal")) {
    const modalEl = document.querySelector(".js-user-modal");

    // eslint-disable-next-line no-undef
    const modal = new Modal(modalEl, {
      backdrop: true,
      keyboard: true,
      focus: true,
    });

    // Open BTN
    document.querySelectorAll(".user-icon")?.forEach(x => x.addEventListener("click", () => {
      modal.show();
    }));
  }
};

export default userPopupOpen;
